// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__XlI9a","author":"Table_author__23nTV","authorImage":"Table_authorImage__3bPR4","unreadRow":"Table_unreadRow__1w5SL"};